import {
  fetchRecommendedVideos,
  fetchVideos,
  fetchRecommendedVideoById,
} from '../../../redux/videoLecture/action';
import { fetchNews } from '../../../redux/news/action';
import {
  fetchInstructors,
  purchaseContent,
  dismissUserRequests,
  updateUser,
  fetchUser,
} from '../../../redux/user/action';
import {
  fetchRecommendedEAPrograms,
  fetchRecommendedEAById,
  downloadEAProgramFile,
  fetchEAPrograms,
} from '../../../redux/EAProgram/action';
import {
  fetchRecommendedProjectContents,
  fetchRecommendedTopicById,
  downloadProjectFile,
  fetchProjectContents as fetchProjects,
} from '../../../redux/projectContent/action';
import { fetchPurchase } from '../../../redux/purchase/action';
import { fetchAds } from '../../../redux/advertisement/action';
import { UserRankTitle } from '../../../domain/entities';
import { createOrUpdateConversation } from '../../../redux/conversation/action';

import {
  signOut,
  retryMailMagazine as registerToMailMagazine,
} from '../../../redux/auth/action';
import { AnyAction } from 'redux';

export type MyPageDispatchProps = { recentlyBoughtKeys: Array<string> };

export const fetchRecommendedFirstRow = (): AnyAction => {
  return fetchRecommendedVideos();
};

export const fetchRecommendedSecondRow = (): AnyAction => {
  return fetchRecommendedProjectContents();
};

export const fetchRecommendedThirdRow = (): AnyAction => {
  return fetchRecommendedEAPrograms();
};

export const getRecommendedVideoById = (id: string): AnyAction => {
  return fetchRecommendedVideoById(id);
};

export const getRecommendedTopicById = (id: string): AnyAction => {
  return fetchRecommendedTopicById(id);
};

export const getRecommendedEAById = (id: string): AnyAction => {
  return fetchRecommendedEAById(id);
};

export const fetchNewsList = (): AnyAction => {
  return fetchNews();
};

export const fetchInstructorsList = (): AnyAction => {
  return fetchInstructors();
};

export const fetchVideoLectures = (): AnyAction => {
  return fetchVideos({
    where: [
      ['isPublished', '==', true],
      ['isDeleted', '==', false],
    ],
    orderBy: 'createdAt',
  });
};

export const fetchEAProgramsContents = (): AnyAction => {
  return fetchEAPrograms({
    where: [
      ['isPublished', '==', true],
      ['isDeleted', '==', false],
    ],
    orderBy: 'createdAt',
  });
};

export const fetchProjectContents = (): AnyAction => {
  return fetchProjects({
    where: [
      ['isPublished', '==', true],
      ['isDeleted', '==', false],
    ],
    orderBy: 'createdAt',
  });
};

export const purchaseContentByKey = (
  userId: string,
  collectionKey: 'manuals' | 'EAPrograms' | 'videoLectures' | 'projectContents',
  itemId: string,
  rank: UserRankTitle,
): AnyAction => {
  return purchaseContent(userId, collectionKey, itemId, rank);
};

export const fetchPurchases = (userId: string): AnyAction => {
  return fetchPurchase(userId, {});
};

export const dismissRequestsOfUser = (actionType: string): AnyAction => {
  return dismissUserRequests(actionType);
};

export const logout = (): AnyAction => {
  return signOut();
};

export const addOrUpdateConversation = (
  params: {
    files?: Array<File>;
    title?: string;
    content: string;
    userId: string;
    instructorId: string;
    senderId: string;
  },
  rank?: UserRankTitle,
): AnyAction => {
  return createOrUpdateConversation(params, rank);
};

export const setHasSeenWelcome = (
  id: string,
  params: { hasSeenWelcomeToast: boolean },
): AnyAction => {
  return updateUser(id, { subscriberProfile: params });
};

export const fetchProjectFileBlob = (url: string): AnyAction => {
  return downloadProjectFile({ url });
};

export const fetchEAProgramFileBlob = (url: string): AnyAction => {
  return downloadEAProgramFile({ url });
};

export const retryMailMagazine = (
  email: string,
  name: string,
  userId: string,
): AnyAction => {
  return registerToMailMagazine(email, name, userId);
};

export const cancelMailMagazine = (
  id: string,
  hasFailedToRegisterToMailMagazine: boolean,
): AnyAction => {
  return updateUser(id, { hasFailedToRegisterToMailMagazine });
};

export const getUser = (id: string): AnyAction => {
  return fetchUser(id);
};

export const getAds = (): AnyAction => {
  return fetchAds();
};

export type DispatchFromProps = {
  fetchRecommendedFirstRow: typeof fetchRecommendedFirstRow;
  fetchRecommendedSecondRow: typeof fetchRecommendedSecondRow;
  fetchRecommendedThirdRow: typeof fetchRecommendedThirdRow;
  fetchNewsList: typeof fetchNewsList;
  fetchInstructorsList: typeof fetchInstructorsList;
  purchaseContentByKey: typeof purchaseContentByKey;
  fetchPurchases: typeof fetchPurchases;
  logout: typeof logout;
  dismissRequestsOfUser: typeof dismissRequestsOfUser;
  addOrUpdateConversation: typeof addOrUpdateConversation;
  setHasSeenWelcome: typeof setHasSeenWelcome;
  fetchVideoLectures: typeof fetchVideoLectures;
  getRecommendedVideoById: typeof getRecommendedVideoById;
  getRecommendedTopicById: typeof getRecommendedTopicById;
  getRecommendedEAById: typeof getRecommendedEAById;
  fetchProjectFileBlob: typeof fetchProjectFileBlob;
  fetchEAProgramFileBlob: typeof fetchEAProgramFileBlob;
  retryMailMagazine: typeof retryMailMagazine;
  cancelMailMagazine: typeof cancelMailMagazine;
  getUser: typeof getUser;
  getAds: typeof getAds;
};
